import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    slide:
      'flex aspect-square h-25 w-25 shrink-0 grow-0 opacity-50 duration-300 hover:opacity-100',
    thumb: 'aspect-square cursor-pointer'
  },
  variants: {
    selected: {
      true: {
        slide: 'opacity-100'
      }
    }
  }
});
